import {ICustomConverter} from '@dhkatz/json-ts';

export class MapNumberBooleanConverter implements ICustomConverter<Map<number, boolean>> {

  public static converter = new MapNumberBooleanConverter();

  public fromJson(data: object): Map<number, boolean> {
    if (data === undefined) return undefined;
    const hashMap = new Map<number, boolean>();
    Object.keys(data).forEach((key) => {
      hashMap.set(+key, data[key]);
    });
    return hashMap;
  }

  public toJson(data: Map<number, boolean>): object {
    const obj = {};
    data.forEach((value, key) => obj[key] = value);
    return obj;
  }
}
